import type { SecondaryOrderStatePath } from 'state/secondaryMarket/secondaryMarket.model';
import type { AppState } from 'state/state.model';

type DefaultStateType = Exclude<SecondaryOrderStatePath, 'cpOrder'>;

export const defaultsSelectorsFactory = (stateType: DefaultStateType) => {
  const select = (state: AppState, tabId: string) => state.secondaryMarket[stateType].defaults[tabId];
  return {
    getDefaultClient: (state: AppState, tabId: string) => select(state, tabId)?.client,
    getDefaultSettlementDate: (state: AppState, tabId: string) => select(state, tabId)?.settlementDate,
    getDefaultTradeWay: (state: AppState, tabId: string) => select(state, tabId)?.tradeWay,
    getDefaultClientType: (state: AppState, tabId: string) => select(state, tabId)?.clientType,
    getDefaultSalesId: (state: AppState, tabId: string) => select(state, tabId)?.salesId,
  };
};
